<template>
  <v-container
    class="main-container"
    fill-height
    @dragover="dragover"
    @dragleave="dragleave"
    @drop="drop"
  >
    <v-row justify="center" align="center">
      <v-col cols="8">
        <v-card color="grey lighten-3 pa-5">            
          <v-card-title class="justify-center">Izaberite ili prevucite excel datoteku.</v-card-title>

          <v-file-input
            label="Excel datoteka"
            @change="onChange"
            @click:clear="clearFileInput()"
            ref="fileInput"
            accept=".xlsx, .xls"
            outlined
            dense
          ></v-file-input>

          <v-row v-if="currentFile != undefined && showChoosedFile">
            <v-col cols="9">
              Izabrana datoteka: {{ currentFile.name }}
            </v-col>
          </v-row>

          <v-card-actions class="justify-center mt-5">
            <v-btn>Učitaj datoteku</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!--  No file chosen dialog  -->
    <v-dialog v-model="showNoChosenFileDialog" persistent width="40%">
      <v-card>
        <v-card-title class="headline">
          Obaveštenje!
        </v-card-title>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="showNoChosenFileDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
    export default {
        name: "UploadXml",
        data() {
            return{
                message: "",
                currentFile: "",
                showNoChosenFileDialog: false,
                showChoosedFile: false,
            }
        },
        methods: {
            clearFileInput() {
                this.currentFile = "";
                this.showChoosedFile = false;
            },
            onChange(e) {
                let file = e;
                this.currentFile = file;
                this.showChoosedFile = true;
            },            
            dragover(event) {
                event.preventDefault();
                // Add some visual effects to show the user can drop its files
                if (!event.currentTarget.classList.contains("bg-green-300")) {
                    event.currentTarget.classList.remove("bg-gray-100");
                    event.currentTarget.classList.add("bg-green-300");
                }
            },
            dragleave(event) {
                // Clean up
                event.currentTarget.classList.add("bg-gray-100");
                event.currentTarget.classList.remove("bg-green-300");
            },
            drop(event) {
                event.preventDefault();

                this.onChange(event.dataTransfer.files[0]);
                // Clean up
                event.currentTarget.classList.add("bg-gray-100");
                event.currentTarget.classList.remove("bg-green-300");
            },
        }
    }
</script>

